import React from "react"
import ScrollableAnchor from "react-scrollable-anchor"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx"
import GridItem from "../../../components/Grid/GridItem.jsx"

import productStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"

class PricingSection extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <div>
                <ScrollableAnchor id="pricing">
                    <div>
                        <div className={classes.pricingSection}>
                            <div style={{ textAlign: "center", marginBottom: "3rem" }}>
                                <h2 className={classes.optimizeBoxTitle}> Pricing Plan </h2>
                                <div className={classes.optimizeDescription} style={{ maxWidth: "100%" }}>
                                    <div>Simple, Predictable Pricing</div>
                                    <div>0% Commission & No Contract or Cancellation Fees!</div>
                                </div>
                            </div>
                            <GridContainer style={{ display: "flex", alignItems: "flex-start", justifyContent: "center" }}>
                                <GridItem xs={0} sm={0} md={3} lg={3} />

                                <GridItem xs={12} sm={12} md={6} lg={6}>
                                    <GridContainer className={classes.featureBoxDescription} spacing={0}>
                                        <GridItem sm={5}>
                                            <div style={{ padding: "1rem 0 3rem 0", fontWeight: "700" }}>
                                                {" "}
                                                <span>Professional</span>{" "}
                                            </div>
                                            <div>
                                                <span
                                                    style={{
                                                        fontSize: "1.5rem",
                                                        fontWeight: "500",
                                                        position: "relative",
                                                        bottom: "1rem",
                                                    }}>
                                                    $
                                                </span>
                                                <span style={{ fontSize: "3rem", fontWeight: "500" }}>99</span>
                                            </div>
                                            <div style={{ padding: "2rem 0 1rem 0" }}>
                                                <span>Per Month.</span>
                                            </div>
                                        </GridItem>
                                        <GridItem
                                            sm={7}
                                            style={{
                                                textAlign: "left",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>Next day deposits</span>
                                            </div>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>$0.05 + 0.05% + Interchange</span>
                                            </div>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>Fully Branded Ordering Site</span>
                                            </div>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>Full Website Design</span>
                                            </div>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>Doordash Integration</span>
                                            </div>
                                            <div
                                                style={{ fontWeight: "500", display: "flex", paddingBottom: "0.5rem" }}>
                                                <i
                                                    className="material-icons"
                                                    style={{ color: "#FFC915", paddingRight: "0.5rem" }}>
                                                    check_circle
                                                </i>
                                                <span>+ $25 for Hardware Lease</span>
                                            </div>
                                            <div
                                                style={{
                                                    fontWeight: "400",
                                                    display: "flex",
                                                    paddingBottom: "0.5rem",
                                                    position: "relative",
                                                    left: "2rem",
                                                    top: "-0.5rem",
                                                }}>
                                                <span>(iPad, Printer, Enclosure and Cables)</span>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>

                                <GridItem xs={0} sm={0} md={3} lg={3} />
                            </GridContainer>
                        </div>
                    </div>
                </ScrollableAnchor>
            </div>
        )
    }
}

export default withStyles(productStyle)(PricingSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/PricingSection.jsx